import {useQueryClient} from "@tanstack/react-query";
import Snackbar from "../../snackbar/Snackbar";
import {ErrorTranslationKey} from "../../ErrorTranslationKey";
import {t} from "../../../../../store/localization/TranslMessasge";
import DeleteConfirmationDialog from "../../../../../components/dialogs/DeleteConfirmationDialog";
import {useRef, useState} from "react";
import {AjaxError} from "rxjs/ajax";
import {StereotypeApiClient} from "../../../../../common/apis/stereotype/StereotypeApiClient";
import {invalidateFindAllStereotypesQueryCache} from "../StereotypeQuery";
import {StereotypesTranslationKey} from "../StereotypesTranslationKey";

export interface ReferenceDefinitionDeleteDialogProps {
    open: boolean;
    stereotypeId: string;
    referenceDefinitionId: string;
    onClose: () => void;
    onDeleted: () => void;
}

export default function ReferenceDefinitionDeleteDialog(props: Readonly<ReferenceDefinitionDeleteDialogProps>) {
    const {open, stereotypeId, referenceDefinitionId, onClose, onDeleted} = props;

    const stereotypeApiClient = useRef(new StereotypeApiClient());
    const [deleteInProgress, setDeleteInProgress] = useState<boolean>(false);

    const queryClient = useQueryClient();

    function deleteDefinition(stereotypeId: string, definitionId: string) {
        setDeleteInProgress(true);
        stereotypeApiClient.current.deleteReference(stereotypeId, definitionId)
            .then(() => {
                onDeleted();
                onClose();
                invalidateFindAllStereotypesQueryCache(queryClient);
                Snackbar.success(t(StereotypesTranslationKey.SMART_REFERENCE_DELETED_SUCCESSFULLY));
            })
            .catch((error: AjaxError) => {
                Snackbar.error(t(ErrorTranslationKey.UNEXPECTED_ERROR_OCCURRED), error);
            })
            .finally(() => setDeleteInProgress(false));
    }

    if (!referenceDefinitionId) {
        return null;
    }

    return (
        <DeleteConfirmationDialog
            open={open}
            title={t(StereotypesTranslationKey.DELETE_SMART_REFERENCE_PROMPT)}
            message={t(StereotypesTranslationKey.SMART_REFERENCE_WILL_BE_DELETED)}
            deleteDisabled={deleteInProgress}
            onDelete={() => deleteDefinition(stereotypeId, referenceDefinitionId)}
            onDismiss={onClose} />
    );
}